const timeouts = /* @__PURE__ */ new Map();
function debounce(cb, ms, id) {
  const timeout = timeouts.get(id);
  if (timeout != null) {
    window.clearTimeout(timeout);
  }
  timeouts.set(
    id,
    window.setTimeout(() => {
      cb();
      timeouts.delete(id);
    }, ms)
  );
}
export {
  debounce
};
